import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

function AboutUs() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link className="active" to="/about-us">About Us</Link>
          <Link to="/dealers">Dealers &amp; Representatives</Link>
          <Link to="/sustainability">Sustainability</Link>
          <Link to="/refurbished">Refurbished Balers</Link>
          <div className="side-contact-list company-sidebar-contact">
            <span>To Get a Price Quotation:</span>
            <a href="mailto:sales@baling.com">sales@baling.com</a>
            <span>To Receive Our Brochures and Literature:</span>
            <a href="mailto:marketing@baling.com">marketing@baling.com</a>
            <span>To Purchase Replacement Parts:</span>
            <a href="mailto:parts@baling.com">parts@baling.com</a>
          </div>
        </aside>
        <article className="article">
          <span className="eyebrow">Company</span>
          <h2>About Us</h2>
          <div className="content-stack">
            <section className="content-block">
              <div className="body-copy"><strong>C&amp;M Baling Systems</strong>, Inc. is a privately owned corporation located in Winston-Salem, North Carolina just off business Interstate 40 east of the city.</div>
              <div className="body-copy">Administrative, sales, engineering, and <strong>manufacturing facilities</strong> are located on an 8-acre tract of land with easy access to most of our suppliers and subcontractors. Our entire product line can be manufactured and assembled within our factory, but specialized subcontractors often provide subassemblies for our <strong>production line</strong> to add additional manufacturing capacity.</div>
              <div className="body-copy">Approximately 40 percent of our products are exported or sold to other companies for marketing under their product brand name. C&amp;M machinery is marketed through dealers, other original equipment manufacturers, and direct to end-users. Production lead-time for finished balers or related machinery and equipment is usually eight to ten weeks.</div>
            </section>
            <section className="content-block">
              <h3>Our Business Philosophy</h3>
              <div className="body-copy">Our owners and employees have a passion to design, fabricate, and assemble balers. It is with that spirit that we excel in designing <strong>custom baling presses</strong> for applications that other baler manufacturers cannot handle.</div>
              <div className="body-copy">Quality and safety are in the forefront of our considerations as custom and standard baler designs are produced. It is the goal of every C&amp;M employee to build the next baler better than the one before. Most C&amp;M employees have many years of service, and have made this their workplace home. We all enjoy what we do every day.</div>
            </section>
            <section className="content-block">
              <h3>At Work</h3>
              <div className="body-copy">Our employees look forward to every Monday morning and have skills to prove it.</div>
              <img className="wide-company-image" src="/img/thumbnails/AboutUsPic1.jpg" alt="C&M employees welding and fabricating baler equipment" />
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default AboutUs;
